export default __webpack_public_path__ + "static/media/2966.02a6feca.png";